import { render } from "./GroomerDashboard.vue?vue&type=template&id=3210402a&scoped=true"
import script from "./GroomerDashboard.vue?vue&type=script&lang=js"
export * from "./GroomerDashboard.vue?vue&type=script&lang=js"

import "./GroomerDashboard.vue?vue&type=style&index=0&id=3210402a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3210402a"]])

export default __exports__